// The two glyphs a design-system checkbox draws. Shared so the shapes are
// defined once: Checkbox uses them inside a real control, and a read-only
// indicator can draw the same mark without one.

export function TickMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 16 16" className={className}>
      <path
        d="M3.5 8.5L6.5 11.5L12.5 4.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DashMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 16 16" className={className}>
      <line
        x1="4"
        y1="8"
        x2="12"
        y2="8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
